import React from "react";
import { booking } from "../data/redlandGolfContent";
import { Breadcrumbs, SectionHeading } from "../components/RedlandComponents";

export default function BookTeeTime() {
  return (
    <>
      <Breadcrumbs current="Book a Tee Time" />
      <section className="section" data-testid="booking-section">
        <div className="container">
          <h1 className="sr-only">Book a Tee Time at Redland Golf &amp; Country Club</h1>
          <SectionHeading
            eyebrow="Tee Times"
            title="Book a Tee Time"
            copy="Reserve your round below. Live availability, member recognition, pricing, and checkout are powered directly by Lightspeed Golf."
          />
          <div className="booking-widget-wrap" data-testid="booking-widget-wrap">
            <iframe
              title="Redland Golf & Country Club tee time booking"
              src={booking.widgetUrl}
              className="booking-iframe"
              loading="eager"
              allow="payment"
              data-testid="booking-iframe"
            />
          </div>
          <p className="booking-fallback">
            Having trouble viewing the booking widget?{" "}
            <a href={booking.widgetUrl} target="_blank" rel="noreferrer" data-testid="booking-external-link">
              Open the Lightspeed Golf booking page in a new tab
            </a>
            .
          </p>
        </div>
      </section>
    </>
  );
}
